import {InDemandCareer, InDemandCareerWrapper} from '@udemy/career-academies';
import {useI18n} from '@udemy/i18n';
import {AIEraCareerBanner} from '@udemy/react-banners';
import {OnePaneLayoutFullWidthSectionContent} from '@udemy/react-layout-components';

import {
    MAIN_BLOG_ARTICLES_DATA,
    TRENDING_TOPICS_BLOG_ARTICLES_DATA,
} from '../../utils/blog-articles-data';
import {ExploreMoreSectionBlog} from './explore-more-section-blog.react-component';
import styles from './explore-more-section.module.less';

export const ExploreMoreSection = ({academies}: {academies: InDemandCareer[]}) => {
    const {gettext} = useI18n();
    const displayedAcademies = academies?.length > 3 ? academies.slice(0, 3) : academies;
    return (
        <OnePaneLayoutFullWidthSectionContent className={styles['explore-more-section']}>
            <h2 className={styles['explore-more-title']}>
                {gettext('Explore more trending topics & top-rated content')}
            </h2>

            <div className={styles['explore-more-career-accelerators']}>
                <div className={styles['explore-more-career-accelerators-title']}>
                    <h3 className={styles['explore-more-career-accelerators-title-text']}>
                        {gettext('Cyber Week savings for career-changing skills')}
                    </h3>
                    <p className={styles['explore-more-career-accelerators-title-description']}>
                        {gettext(
                            'Get the skills and real-world experience employers want with Career Accelerators.',
                        )}
                    </p>
                </div>
                <InDemandCareerWrapper
                    academies={displayedAcademies}
                    buttonProps={{udStyle: 'ghost'}}
                    headingProps={{className: styles['hide']}}
                    className={styles['explore-more-section-in-demand-careers']}
                />
            </div>
            <ExploreMoreSectionBlog
                articles={MAIN_BLOG_ARTICLES_DATA}
                title={gettext('Advance or pivot careers with interview tips and more')}
            />
            <ExploreMoreSectionBlog
                articles={TRENDING_TOPICS_BLOG_ARTICLES_DATA}
                title={gettext('Stay ahead with free resources on trending topics')}
            />
            <AIEraCareerBanner />
        </OnePaneLayoutFullWidthSectionContent>
    );
};
